module.exports = __webpack_public_path__ + "img/video-recorder.54d75675.svg";